import { useRef, useState } from 'react'
import Navbar from '../../components/navbar/navbar'
import Select from 'react-select'
import waitingTimeSvg from '../../assets/illustration/waiting-time.svg'
import { toast } from 'react-toastify'
import ProdutosService from '../../services/database/ProdutosService'
import { CustomSpinner } from '../../components/CustomSpinner'
import { CustomButton } from '../../components/CustomButton'
import { Form } from 'react-bootstrap'
import { CheckCircleFill, Search, TrashFill, XCircleFill } from 'react-bootstrap-icons'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

// ─── Design tokens ───────────────────────────────────────────────────────────
const C = {
  bg:       '#f8f9fc',
  surface:  '#ffffff',
  border:   '#e8eaf2',
  accent:   '#4f46e5',
  accentLt: '#eef2ff',
  success:  '#059669',
  successLt:'#d1fae5',
  danger:   '#dc2626',
  dangerLt: '#fee2e2',
  text:     '#1a1a2e',
  sub:      '#64748b',
  muted:    '#94a3b8',
  radius:   '12px',
  radiusSm: '8px',
  shadow:   '0 1px 3px rgba(0,0,0,0.08), 0 4px 16px rgba(79,70,229,0.06)',
  shadowHov:'0 4px 20px rgba(79,70,229,0.15)',
}

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minWidth: 220,
    borderRadius: C.radiusSm,
    border: `1.5px solid ${state.isFocused ? C.accent : C.border}`,
    boxShadow: state.isFocused ? `0 0 0 3px ${C.accentLt}` : 'none',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.875rem',
    background: C.surface,
    transition: 'all 0.2s',
    '&:hover': { borderColor: C.accent },
  }),
  option: (base, state) => ({
    ...base,
    background: state.isSelected ? C.accent : state.isFocused ? C.accentLt : 'transparent',
    color: state.isSelected ? '#fff' : C.text,
    fontSize: '0.875rem',
    fontFamily: "'DM Sans', sans-serif",
    borderRadius: 6,
    margin: '2px 4px',
    width: 'calc(100% - 8px)',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: C.radius,
    border: `1px solid ${C.border}`,
    boxShadow: C.shadow,
    overflow: 'hidden',
  }),
  placeholder: (base) => ({ ...base, color: C.muted, fontSize: '0.875rem' }),
  singleValue: (base) => ({ ...base, color: C.text, fontSize: '0.875rem' }),
}

export function AjusteEstoque() {
  const [produtos, setProdutos]               = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  const [productSearch, setProductSearch]     = useState('')
  const [type, setType]                       = useState('')
  const [reason, setReason]                   = useState('')
  const [isLoadingProdutos, setIsLoadingProdutos]           = useState(false)
  const [isRequestAdjustLoading, setIsRequestAdjustLoading] = useState(false)
  const buttonSearchRef = useRef(null)

  const optionsTipoAjuste = [
    { label: 'Entrada', value: 'Entrada' },
    { label: 'Saída',   value: 'Saída'   },
  ]

  const typeEntrada = [
    { label: 'Compra',    value: 'Compra'    },
    { label: 'Troca',     value: 'Troca'     },
    { label: 'Devolução', value: 'Devolução' },
  ]

  const typeSaida = [
    { label: 'Venda',     value: 'Venda'     },
    { label: 'Troca',     value: 'Troca'     },
    { label: 'Devolução', value: 'Devolução' },
    { label: 'Avaria',    value: 'Avaria'    },
  ]

  function handleQtdToTransfer(value, index) {
    const updated = [...selectedProducts]
    updated[index].quantityToTransfer = value
    setSelectedProducts(updated)
  }

  async function handleSearchProduct() {
    setIsLoadingProdutos(true)
    try {
      const data = await ProdutosService.getAllToAdjust(localStorage.idconta, productSearch)
      if (data.length === 0) toast.error('Não foi possível encontrar este produto!')
      setProdutos(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao listar os produtos!')
    } finally {
      setIsLoadingProdutos(false)
    }
  }

  function handleSelectProduct(product) {
    for (const sel of selectedProducts) {
      if (sel.codproduto === product.codproduto) {
        setProdutos(p => p.filter(pr => pr !== product))
        return
      }
    }
    setProdutos(p => p.filter(pr => pr !== product))
    setSelectedProducts(p => [...p, { ...product, quantityToTransfer: 0 }])
  }

  function resetStates() {
    setProdutos([]); setSelectedProducts([]); setProductSearch('')
    setType(''); setReason('')
    setIsLoadingProdutos(false); setIsRequestAdjustLoading(false)
  }

  async function handleSubmit(e) {
    e.preventDefault()
    setIsRequestAdjustLoading(true)
    try {
      await ProdutosService.updateStock({ type, reason, selectedProducts })
      toast.success('Estoque ajustado com sucesso!')
      resetStates()
    } catch (error) {
      toast.error('Erro ao transferir o estoque!')
    } finally {
      setIsRequestAdjustLoading(false)
    }
  }

  const isEntrada = type?.value === 'Entrada'

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
        .ajuste-root * { font-family: 'DM Sans', sans-serif; box-sizing: border-box; }
        .produto-item {
          padding: 12px 16px; border-radius: ${C.radiusSm};
          border: 1.5px solid ${C.border}; background: ${C.surface};
          cursor: pointer; transition: all 0.15s;
          display: flex; align-items: center; gap: 10px;
        }
        .produto-item:hover {
          border-color: ${C.accent}; background: ${C.accentLt};
          transform: translateX(2px);
        }
        .prod-row { transition: background 0.15s; }
        .prod-row:hover { background: ${C.accentLt} !important; }
        .qtd-input {
          border: 1.5px solid ${C.border} !important; border-radius: ${C.radiusSm} !important;
          font-size: 0.875rem !important; padding: 6px 10px !important;
          transition: border-color 0.2s, box-shadow 0.2s !important; width: 90px !important;
        }
        .qtd-input:focus {
          border-color: ${C.accent} !important;
          box-shadow: 0 0 0 3px ${C.accentLt} !important; outline: none !important;
        }
        .search-input {
          border: 1.5px solid ${C.border}; border-radius: ${C.radiusSm} 0 0 ${C.radiusSm} !important;
          font-size: 0.875rem; padding: 8px 14px; color: ${C.text};
          transition: border-color 0.2s, box-shadow 0.2s; outline: none;
          flex: 1;
        }
        .search-input:focus {
          border-color: ${C.accent}; box-shadow: 0 0 0 3px ${C.accentLt};
        }
        .btn-submit {
          display: flex; align-items: center; gap: 8px;
          background: ${C.success}; color: #fff; border: none;
          border-radius: ${C.radius}; padding: 12px 24px;
          font-size: 0.9rem; font-weight: 600; cursor: pointer;
          box-shadow: 0 4px 12px rgba(5,150,105,0.3);
          transition: all 0.2s;
        }
        .btn-submit:hover { background: #047857; transform: translateY(-1px); box-shadow: 0 6px 16px rgba(5,150,105,0.4); }
        .btn-submit:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
      `}</style>

      <Navbar />

      <div className="ajuste-root" style={{ background: C.bg, minHeight: '100vh', paddingBottom: 100, width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <div className="mt-page" style={{ padding: '28px 32px', width: '100%' }}>

            {/* ── Header ── */}
            <div style={{ marginBottom: 28 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6 }}>
                <div style={{
                  width: 4, height: 32, borderRadius: 2,
                  background: `linear-gradient(180deg, ${C.accent}, #818cf8)`,
                }} />
                <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800, color: C.text, letterSpacing: '-0.02em' }}>
                  Ajuste de Estoque
                </h1>
              </div>
              <p style={{ margin: 0, color: C.sub, fontSize: '0.875rem', paddingLeft: 16 }}>
                Gerencie entradas e saídas do seu estoque
              </p>
            </div>

            {/* ── Filtros ── */}
            <div style={{
              background: C.surface, borderRadius: C.radius,
              border: `1px solid ${C.border}`, padding: '20px 24px',
              boxShadow: C.shadow, marginBottom: 24,
            }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'flex-end' }}>

                {/* Tipo */}
                <div>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: C.sub, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    Movimentação
                  </label>
                  <Select
                    placeholder="Selecione..."
                    options={optionsTipoAjuste}
                    value={type}
                    styles={selectStyles}
                    onChange={(e) => { setType(e); setReason(''); setSelectedProducts([]) }}
                  />
                </div>

                {/* Motivo */}
                <div>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: C.sub, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    Motivo
                  </label>
                  <Select
                    placeholder="Selecione..."
                    isDisabled={!type}
                    options={type?.value === 'Entrada' ? typeEntrada : typeSaida}
                    value={reason}
                    styles={selectStyles}
                    onChange={setReason}
                  />
                </div>

                {/* Busca */}
                <div style={{ flex: 1, minWidth: 280 }}>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: C.sub, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    Produto
                  </label>
                  <div style={{ display: 'flex' }}>
                    <input
                      className="search-input"
                      value={productSearch}
                      onChange={e => setProductSearch(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && buttonSearchRef.current?.click()}
                      placeholder="Digite o SKU ou descrição..."
                    />
                    <button
                      ref={buttonSearchRef}
                      type="button"
                      disabled={!productSearch || isLoadingProdutos}
                      onClick={handleSearchProduct}
                      style={{
                        padding: '8px 16px',
                        background: productSearch ? C.accent : C.border,
                        color: productSearch ? '#fff' : C.muted,
                        border: 'none',
                        borderRadius: `0 ${C.radiusSm} ${C.radiusSm} 0`,
                        cursor: productSearch ? 'pointer' : 'not-allowed',
                        transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: 6,
                        fontSize: '0.875rem', fontWeight: 600,
                      }}
                    >
                      {isLoadingProdutos
                        ? <span style={{ width: 16, height: 16, border: '2px solid #fff4', borderTop: '2px solid #fff', borderRadius: '50%', display: 'inline-block', animation: 'spin 0.8s linear infinite' }} />
                        : <Search size={14} />}
                      Buscar
                    </button>
                  </div>
                </div>

              </div>
            </div>

            {/* ── Resultados da busca ── */}
            {isLoadingProdutos ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                <CustomSpinner />
              </div>
            ) : produtos.length > 0 ? (
              <div style={{
                background: C.surface, borderRadius: C.radius,
                border: `1px solid ${C.border}`, boxShadow: C.shadow,
                marginBottom: 24, overflow: 'hidden',
              }}>
                <div style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '14px 20px', borderBottom: `1px solid ${C.border}`,
                  background: '#fafafc',
                }}>
                  <span style={{ fontSize: '0.8rem', fontWeight: 600, color: C.sub }}>
                    {produtos.length} produto(s) encontrado(s) — clique para selecionar
                  </span>
                  <button
                    type="button"
                    onClick={() => setProdutos([])}
                    style={{
                      background: 'none', border: 'none', cursor: 'pointer',
                      color: C.muted, display: 'flex', alignItems: 'center', gap: 4,
                      fontSize: '0.8rem', padding: '4px 8px', borderRadius: 6,
                      transition: 'color 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = C.danger}
                    onMouseLeave={e => e.currentTarget.style.color = C.muted}
                  >
                    <XCircleFill size={13} /> Limpar
                  </button>
                </div>
                <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 8, maxHeight: 300, overflowY: 'auto' }}>
                  {produtos.map(produto => (
                    <div
                      key={produto.codproduto}
                      className="produto-item"
                      onClick={() => handleSelectProduct(produto)}
                    >
                      <div style={{
                        width: 32, height: 32, borderRadius: 8,
                        background: C.accentLt, display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                      }}>
                        <span style={{ fontSize: '0.65rem', fontWeight: 800, color: C.accent }}>
                          {produto.sku?.slice(0, 2)?.toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <div style={{ fontSize: '0.82rem', fontWeight: 700, color: C.text }}>
                          {produto.sku}
                        </div>
                        <div style={{ fontSize: '0.75rem', color: C.sub }}>{produto.descricao}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : selectedProducts.length === 0 ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: '32px 0' }}>
                <img src={waitingTimeSvg} style={{ width: 320, opacity: 0.85 }} alt="Aguardando" />
              </div>
            ) : null}

            {/* ── Produtos selecionados ── */}
            {selectedProducts.length > 0 && (
              <div style={{
                background: C.surface, borderRadius: C.radius,
                border: `1px solid ${C.border}`, boxShadow: C.shadow,
                overflow: 'hidden',
              }}>
                {/* Header da tabela */}
                <div style={{
                  padding: '16px 20px', borderBottom: `1px solid ${C.border}`,
                  background: '#fafafc', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{
                      width: 28, height: 28, borderRadius: 8,
                      background: C.accentLt, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      <CheckCircleFill size={13} color={C.accent} />
                    </div>
                    <span style={{ fontWeight: 700, color: C.text, fontSize: '0.95rem' }}>
                      Produtos Selecionados
                    </span>
                    <span style={{
                      background: C.accentLt, color: C.accent,
                      fontSize: '0.7rem', fontWeight: 700,
                      padding: '2px 8px', borderRadius: 99,
                    }}>
                      {selectedProducts.length}
                    </span>
                  </div>
                  {type?.value && (
                    <span style={{
                      padding: '4px 12px', borderRadius: 99, fontSize: '0.75rem', fontWeight: 700,
                      background: isEntrada ? C.successLt : C.dangerLt,
                      color: isEntrada ? C.success : C.danger,
                    }}>
                      {isEntrada ? '↑ Entrada' : '↓ Saída'}
                      {reason?.value ? ` · ${reason.value}` : ''}
                    </span>
                  )}
                </div>

                {/* Tabela */}
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.83rem' }}>
                    <thead>
                      <tr style={{ background: '#f8f9fc' }}>
                        {['Cód. Produto', 'SKU', 'Descrição', 'Estoque Atual', 'Qtd. a Ajustar', 'Ações'].map((h, i) => (
                          <th key={i} style={{
                            padding: '10px 16px', textAlign: i >= 3 ? 'center' : 'left',
                            fontSize: '0.7rem', fontWeight: 700, color: C.sub,
                            textTransform: 'uppercase', letterSpacing: '0.07em',
                            borderBottom: `1px solid ${C.border}`, whiteSpace: 'nowrap',
                          }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {selectedProducts.map((product, index) => (
                        <tr key={product.codproduto} className="prod-row" style={{ borderBottom: `1px solid ${C.border}` }}>
                          <td style={{ padding: '12px 16px', color: C.sub, fontSize: '0.78rem' }}>
                            <code style={{ background: '#f0f4ff', padding: '2px 6px', borderRadius: 4, color: C.accent, fontSize: '0.75rem' }}>
                              {product.codproduto}
                            </code>
                          </td>
                          <td style={{ padding: '12px 16px', fontWeight: 700, color: C.text }}>
                            {product.sku}
                          </td>
                          <td style={{ padding: '12px 16px', color: C.sub, maxWidth: 280 }}>
                            <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {product.descricao}
                            </span>
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                              minWidth: 48, padding: '3px 10px', borderRadius: 99,
                              background: (product.qtestger ?? 0) > 0 ? C.successLt : C.dangerLt,
                              color: (product.qtestger ?? 0) > 0 ? C.success : C.danger,
                              fontWeight: 700, fontSize: '0.82rem',
                            }}>
                              {product.qtestger ?? 0}
                            </span>
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                            <input
                              className="qtd-input"
                              type="number"
                              min="1"
                              required
                              value={selectedProducts[index].quantityToTransfer}
                              onChange={e => handleQtdToTransfer(e.target.value, index)}
                            />
                          </td>
                          <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                            <button
                              type="button"
                              onClick={() => setSelectedProducts(p => p.filter(pr => pr.sku !== product.sku))}
                              className="btn-trash"
                            >
                              <TrashFill size={13} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

          </div>

          {/* ── Botão fixo ── */}
          {selectedProducts.length > 0 && (
            <div style={{
              position: 'fixed', bottom: 24, right: 32,
              display: 'flex', alignItems: 'center', gap: 12, zIndex: 100,
            }}>
              <div style={{
                background: C.surface, borderRadius: C.radius,
                border: `1px solid ${C.border}`, padding: '8px 16px',
                boxShadow: C.shadow, fontSize: '0.8rem', color: C.sub,
              }}>
                {selectedProducts.length} produto(s) · {type?.label ?? '—'} · {reason?.label ?? '—'}
              </div>
              <button
                type="submit"
                className="btn-submit"
                disabled={selectedProducts.length === 0 || !type?.value || !reason?.value || isRequestAdjustLoading}
              >
                {isRequestAdjustLoading
                  ? <span style={{ width: 16, height: 16, border: '2px solid #fff4', borderTop: '2px solid #fff', borderRadius: '50%', display: 'inline-block', animation: 'spin 0.8s linear infinite' }} />
                  : <CheckCircleFill size={15} />}
                Ajustar Estoque
              </button>
            </div>
          )}
        </form>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </>
  )
}